import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    this.toggleScrollLock(true)
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.toggleScrollLock(false)
  }

  // Handle ESC key to close
  handleKeydown(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }
}
